/**
 * Brand asset URLs — served from Cloudinary with on-the-fly format/quality
 * optimisation (`f_auto,q_auto`) so browsers receive WebP/AVIF when supported.
 *
 * Why CDN over the app bundle:
 *   - Loads in parallel with JS chunks (different origin, no head-of-line block)
 *   - Survives deploys / 502s during restarts
 *   - Cloudinary's edge cache + auto-format slashes file size by ~80%
 *     (e.g. the 1.7 MB leg-day PNG drops to ~150 KB as WebP)
 *
 * To swap an asset, re-run `python /app/scripts/upload_brand_to_cloudinary.py`
 * — public_ids are stable so the URLs below stay valid.
 */
const CLOUDINARY_BASE =
  "https://res.cloudinary.com/dkfp3rb3q/image/upload/f_auto,q_auto/ta-fitness/brand";

export const BRAND_LOGO = `${CLOUDINARY_BASE}/ta-fitness-logo.png`;
export const BRAND_MONOGRAM = `${CLOUDINARY_BASE}/ta-monogram.png`;
export const BRAND_XEVIAN_LOGO = `${CLOUDINARY_BASE}/xevian-logo.png`;
export const BRAND_LEG_DAY_SQUAT = `${CLOUDINARY_BASE}/leg-day-squat.png`;
